module.exports = __webpack_public_path__ + "media/images/category/feature/profile/profile-steve-16aef982e6e32e09a947e4345af22af6.jpg";